<template>
  <div class="content">
    
    <!-- Konten utama -->
    <div class="container-fluid mt-4">
      
      <!-- Baris pertama: Kartu statistik -->
      <div class="row mb-4">
        <!-- Total Vessel Aktif -->
         <div class="col-lg-3 col-md-6 mb-4">
          <div class="card card-radius h-100" style="background: linear-gradient(135deg, #4CAF50, #45a049);">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="text-white text-uppercase font-weight-bold">Vessel Active</h6>
                  
                  <h3 v-if="loadingVessel" class="text-white font-weight-bold">
                    <i class="fa fa-spinner fa-spin"></i>
                  </h3>
                  <h3 v-else class="text-white font-weight-bold">
                    {{ totalVesselAktif }}
                  </h3>
                  
                  <p class="text-white small mb-0">
                  <span class="status-dot"></span> Status: <strong>ACTIVE</strong>
                </p>
                
                <div class="trend-note mt-2">
                  <i class="fas fa-chart-line mr-1"></i>
                  <span class="text-white font-weight-bold">
                      {{ vesselTrend >= 0 ? '+' : '' }}{{ vesselTrend }}% 
                      <span class="opacity-75 font-weight-normal ml-1">Current month</span>
                  </span>
                  
                </div>
                </div>
               <div class="icon-circle-wrapper">
                    <i class="fa fa-ship text-white"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      
        <!-- Vassel Suspensions -->
        <div class="col-lg-3 col-md-6 mb-4">
          <div 
            class="card card-radius h-100"
            style="background: linear-gradient(135deg, #2196F3, #1976D2); cursor:pointer;"
            @click="goToSuspensions"
          >
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="text-white text-uppercase font-weight-bold">
                    Vassel Suspensions
                  </h6>
                  <h3 class="text-white font-weight-bold">
                    {{ totalVesselSuspensions }}
                  </h3>
                  <p class="text-white small mb-0">
                    <span class="status-dot"></span>
                    Status: <strong>SUSPENSIONS</strong>
                  </p>
                  <div class="trend-note mt-2">
                    <i class="fas fa-chart-line mr-1"></i>
                    <span class="text-white font-weight-bold">
                      {{ vesselTrendSuspension >= 0 ? '+' : '' }}{{ vesselTrendSuspension }}%
                      <span class="opacity-75 font-weight-normal ml-1">
                        Current month
                      </span>
                    </span>
                  </div>
                </div>
                <div class="icon-circle-wrapper">
                  <i class="fa fa-ship text-white"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Vassel EXPIRED -->
         <div class="col-lg-3 col-md-6 mb-4">
            <div 
              class="card card-radius h-100"
              style="background: linear-gradient(135deg, #E91E63, #C2185B); cursor:pointer;"
              @click="goToExpired"
            >
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 class="text-white text-uppercase font-weight-bold">
                      Vassel Expired
                    </h6>

                    <h3 class="text-white font-weight-bold">
                      {{ totalVesselExpired }}
                    </h3>

                    <p class="text-white small mb-0">
                      <span class="status-dot"></span> 
                      Status: <strong>EXPIRED</strong>
                    </p>

                    <div class="trend-note mt-2">
                      <i class="fas fa-chart-line mr-1"></i>

                      <span class="text-white font-weight-bold">
                        {{ vesselTrendExpired >= 0 ? '+' : '' }}{{ vesselTrendExpired }}%
                        <span class="opacity-75 font-weight-normal ml-1">
                          Current month
                        </span>
                      </span>
                    </div>
                  </div>

                  <div class="icon-circle-wrapper">
                    <i class="fa fa-ship text-white"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <!-- Vassel  MAINTENANCE -->
         <div class="col-lg-3 col-md-6 mb-4">
          <div 
            class="card card-radius h-100"
            style="background: linear-gradient(135deg, #FF9800, #F57C00); cursor:pointer;"
            @click="goToMaintenance"
          >
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="text-white text-uppercase font-weight-bold">
                    Vassel Maintenance
                  </h6>

                  <h3 class="text-white font-weight-bold">
                    {{ totalVesselMaintenance }}
                  </h3>

                  <div class="trend-note mt-2">
                    <i class="fas fa-chart-line mr-1"></i>

                    <span class="text-white font-weight-bold">
                      {{ vesselTrendMaintenance >= 0 ? '+' : '' }}{{ vesselTrendMaintenance }}%
                      <span class="opacity-75 font-weight-normal ml-1">
                        Current month
                      </span>
                    </span>
                  </div>
                </div>

                <div class="icon-circle-wrapper">
                  <i class="fa fa-ship text-white"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-lg-3 col-md-6 mb-4">
          <div class="card card-radius h-100" style="background: linear-gradient(135deg, #FF9800, #F57C00);">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="text-white text-uppercase font-weight-bold">Vassel Maintenance</h6>
                  <h3 class="text-white font-weight-bold">
                     {{ totalVesselMaintenance }}
                  </h3>
                  <div class="trend-note mt-2">
                  <i class="fas fa-chart-line mr-1"></i>
                  <span class="text-white font-weight-bold">
                      {{ vesselTrendMaintenance >= 0 ? '+' : '' }}{{ vesselTrendMaintenance }}% 
                      <span class="opacity-75 font-weight-normal ml-1">Current month</span>
                  </span>
                </div>
                </div>
                <div class="icon-circle-wrapper">
                    <i class="fa fa-ship text-white"></i>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <!-- airtime deep tempo 2month -->
        <div class="col-lg-3 col-md-6 mb-4">
          <div class="card card-radius h-100" style="background: linear-gradient(135deg, #3F51B5, #303F9F);">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="text-white text-uppercase font-weight-bold">Airtime 2 Month</h6>
                  <h3 class="text-white font-weight-bold">
                    {{ totalAirtime2month }}
                  </h3>
                  <div class="trend-note mt-2">
                  <i class="fas fa-chart-line mr-1"></i>
                  <span class="text-white font-weight-bold">
                      {{ airtime2month >= 0 ? '+' : '' }}{{ airtime2month }}% 
                      <span class="opacity-75 font-weight-normal ml-1">due in 2 months</span>
                  </span>
                </div>
                </div>
                <div class="icon-circle-wrapper">
                    <i class="fa fa-clock-o mr-1 text-white"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- airtime deep tempo 1month -->
        <div class="col-lg-3 col-md-6 mb-4">
          <div class="card card-radius h-100" style="background: linear-gradient(135deg, #9C27B0, #8E24AA);">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="text-white text-uppercase font-weight-bold">Airtime 1 Month</h6>
                  <h3 class="text-white font-weight-bold">
                     {{ totalAirtime1month }}
                  </h3>
                  <div class="trend-note mt-2">
                  <i class="fas fa-chart-line mr-1"></i>
                  <span class="text-white font-weight-bold">
                      {{ airtime1month >= 0 ? '+' : '' }}{{ airtime1month }}% 
                      <span class="opacity-75 font-weight-normal ml-1">due in 1 months</span>
                  </span>
                </div>
                </div>
                <div class="icon-circle-wrapper">
                    <i class="fa fa-clock-o mr-1 text-white"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--  airtime deep tempo 2week -->
        <div class="col-lg-3 col-md-6 mb-4">
          <div class="card card-radius h-100" style="background: linear-gradient(135deg, #FFC107, #FFA000);">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="text-white text-uppercase font-weight-bold">Airtime 2 Week</h6>
                  <h3 class="text-white font-weight-bold">
                   {{ totalAirtime2week }}
                  </h3>
                 <div class="trend-note mt-2">
                  <i class="fas fa-chart-line mr-1"></i>
                  <span class="text-white font-weight-bold">
                      {{ airtimeweek >= 0 ? '+' : '' }}{{ airtimeweek }}% 
                      <span class="opacity-75 font-weight-normal ml-1">due in 2 week</span>
                  </span>
                </div>
                </div>
                <div class="icon-circle-wrapper">
                    <i class="fa fa-clock-o mr-1 text-white"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Total Customers -->
        <div class="col-lg-3 col-md-6 mb-4">
          <div class="card card-radius h-100" style="background: linear-gradient(135deg, #F44336, #D32F2F);">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="text-white text-uppercase font-weight-bold">Total Customers</h6>
                  <h3 class="text-white font-weight-bold">
                    {{ totalCustomers }}
                  </h3>
                  <div class="trend-note mt-2">
                  <i class="fas fa-chart-line mr-1"></i>
                  <span class="text-white font-weight-bold">
                      {{ customer >= 0 ? '+' : '' }}{{ customer }}% 
                      <span class="opacity-75 font-weight-normal ml-1">Current month</span>
                  </span>
                </div>
                </div>
                <div class="icon-circle-wrapper">
                    <i class="fa fa-users mr-1 text-white"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Baris kedua: Grafik -->
      <div class="row mb-4">
        <!-- Grafik Troubleshoot -->
        <div class="col-lg-6 mb-4">
          <div class="card card-radius shadow-sm border-0">
            <div class="card-header bg-white border-0 py-3">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h5 class="card-title mb-0 font-weight-bold text-dark">Grafik Troubleshoot</h5>
                  <small class="text-muted">complaints per category</small>
                </div>
              </div>
              
              <div class="d-flex mt-3">
                <select v-model="filterTS.status" @change="updateTSChart" class="custom-select custom-select-sm mr-2 border-light shadow-none">
                  <option value="all">All Complaints</option>
                  <option v-for="item in complaintLabels" :key="item" :value="item">{{ item }}</option>
                </select>
                
                <select v-model="filterTS.month" @change="updateTSChart" class="custom-select custom-select-sm mr-2 border-light shadow-none" style="width: 110px;">
                  <option v-for="(name, index) in monthNames" :key="index" :value="index + 1">{{ name }}</option>
                </select>

                <select v-model="filterTS.year" @change="updateTSChart" class="custom-select custom-select-sm border-light shadow-none" style="width: 90px;">
                  <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
                </select>
              </div>
            </div>

            <div class="card-body">
              <div style="position: relative; height: 350px;">
                <canvas id="troubleshootChart"></canvas>
              </div>
            </div>
          </div>
      </div>   
       
        <div class="col-lg-6 mb-4"> 
          <div class="card card-radius shadow-sm">
            <div class="card-header bg-white border-0 py-3">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h5 class="card-title mb-0 font-weight-bold">Sales Analysis</h5>
                  <small class="text-muted">Monitor monthly revenue performance</small>
                </div>
                <div class="d-flex align-items-center">
                  <select v-model="filter.category" @change="fetchSalesData" class="custom-select custom-select-sm mr-2 shadow-none border-light">
                    <option value="airtime">Airtime</option>
                    <option value="invoice">Invoice Unit</option>
                  </select>
                  
                  <select v-model="filter.year" @change="fetchSalesData" class="custom-select custom-select-sm mr-2 shadow-none border-light">
                    <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                  </select>

                  <select v-model="filter.month" @change="updateChart" class="custom-select custom-select-sm shadow-none border-light">
                    <option value="all">Semua Bulan</option>
                    <option v-for="(name, index) in monthNames" :key="index" :value="index + 1">{{ name }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div style="position: relative; height: 390px;">
                <canvas id="salesChart"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

      <!-- Baris ketiga: Statistik tambahan -->
      <div class="row">
        <!-- Total Pendapatan -->
        <!-- <div class="col-lg-4 col-md-6 mb-4">
          <div class="card card-radius h-100" style="background: linear-gradient(135deg, #2196F3, #1976D2);">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="text-white text-uppercase font-weight-bold">Total Pendapatan</h6>
                  <h3 class="text-white font-weight-bold">Rp 45,890,000</h3>
                  <p class="text-white mt-2 opacity-75">Bulan ini</p>
                </div>
                <div class="text-white">
                  <i class="fa fa-dollar-sign fa-2x"></i>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <!-- Order Baru -->
        <!-- <div class="col-lg-4 col-md-6 mb-4">
          <div class="card card-radius h-100" style="background: linear-gradient(135deg, #4CAF50, #45a049);">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="text-white text-uppercase font-weight-bold">Order Baru</h6>
                  <h3 class="text-white font-weight-bold">128</h3>
                  <p class="text-white mt-2 opacity-75">Hari ini</p>
                </div>
                <div class="text-white">
                  <i class="fa fa-shopping-cart fa-2x"></i>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <!-- Aktif Pengguna -->
        <!-- <div class="col-lg-4 col-md-6 mb-4">
          <div class="card card-radius h-100" style="background: linear-gradient(135deg, #9C27B0, #8E24AA);">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="text-white text-uppercase font-weight-bold">Aktif Pengguna</h6>
                  <h3 class="text-white font-weight-bold">1,892</h3>
                  <p class="text-white mt-2 opacity-75">Sesi aktif</p>
                </div>
                <div class="text-white">
                  <i class="fa fa-user-friends fa-2x"></i>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <!-- <div class="container-fluid pt-2 pb-4 px-md-5">
         
          <div class="row ">
            <div class="col-12">
              <div class="card border-0 shadow-sm" style="border-radius: 15px;">
                <div class="card-header bg-white border-0 pt-4 px-4 d-flex justify-content-between align-items-center">
                  
                  <h5 class="font-weight-bold text-dark mb-0">Annual Income Analysis</h5>

                  <div class="d-flex align-items-center bg-light px-3 py-2 rounded-pill">
                      <select v-model="filter.category" @change="fetchAirtimeData" class="custom-select custom-select-sm mr-2 shadow-none border-light">
                        <option value="airtime">Airtime</option>
                        <option value="invoice">Invoice Unit</option>
                      </select>
                    <small class="mr-3 font-weight-bold text-muted text-uppercase" style="font-size: 11px; letter-spacing: 0.5px;">Periode:</small>
                    <div class="d-flex" style="gap: 5px;">
                      <select v-model="filter.month" @change="updateAirtimeDashboard" 
                              class="custom-select custom-select-sm border-0 shadow-none bg-transparent" 
                              style="width: 110px; cursor: pointer;">
                        <option v-for="(name, index) in monthNames" :key="index" :value="index + 1">{{ name }}</option>
                      </select>
                      
                      <select v-model="filter.year" @change="fetchAirtimeData" 
                              class="custom-select custom-select-sm border-0 shadow-none bg-transparent" 
                              style="width: 80px; cursor: pointer;">
                        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                      </select>
                    </div>
                  </div>

                </div>

                <div class="card-body px-4 pb-4">
                  <div style="height: 350px;">
                    <canvas id="airtimeRevenueChart"></canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <!-- Baris keempat: Aktivitas Terbaru -->
      <div class="row">
        <div class="col-12">
          <div class="card card-radius">
            <div class="card-header bg-white">
              <h5 class="card-title mb-0">Recent Activity</h5>
            </div>
            <div class="card-body">
              <div class="list-group">
                    <div 
                      v-if="recentActivitiesAirtime && recentActivitiesAirtime.invoice_no" 
                      class="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <div class="d-flex align-items-center">
                        <div class="mr-3">
                          <i class="fas fa-clock text-primary"></i> 
                        </div>
                        <div>
                          <p class="mb-0 font-weight-bold">
                            Airtime Invoice #{{ recentActivitiesAirtime.invoice_no }}
                          </p>
                          <small class="text-muted">
                            Dibuat untuk: {{ recentActivitiesAirtime.client_name }}
                          </small>
                        </div>
                      </div>
                      <div>
                        <small class="text-muted">
                          {{ formatDate(recentActivitiesAirtime.created_at) }}
                        </small>
                      </div>
                    </div>

                    <div v-else class="list-group-item text-center text-muted py-3">
                      Tidak ada aktivitas pembuatan invoice airtime baru-baru ini.
                    </div>
                    
                <div 
                      v-if="recentActivitiesInvoiceItem && recentActivitiesInvoiceItem.invoice_no" 
                      class="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <div class="d-flex align-items-center">
                        <div class="mr-3">
                          <i class="fas fa-clock text-primary"></i> 
                        </div>
                        <div>
                          <p class="mb-0 font-weight-bold">
                            Invoice Unit #{{ recentActivitiesInvoiceItem.invoice_no }}
                          </p>
                          <small class="text-muted">
                            Dibuat untuk: {{ recentActivitiesInvoiceItem.client_name }}
                          </small>
                        </div>
                      </div>
                      <div>
                        <small class="text-muted">
                          {{ formatDate(recentActivitiesInvoiceItem.created_at) }}
                        </small>
                      </div>
                    </div>

                    <div v-else class="list-group-item text-center text-muted py-3">
                      Tidak ada aktivitas pembuatan invoice airtime baru-baru ini.
                    </div>
                <!-- <div class="list-group-item d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <div class="mr-3">
                      <i class="fa fa-database text-blue"></i>
                    </div>
                    <div>
                      <p class="mb-0">Dumy Data Forward KKP Update</p>
                      <small class="text-muted">3,745 GB data diproses</small>
                    </div>
                  </div>
                  <div>
                    <small class="text-muted">6 jam lalu</small>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
 import * as axios from 'axios';
 import moment from 'moment'
 import ChartCard from 'src/components/Cards/ChartCard.vue'
 import StatsCard from 'src/components/Cards/StatsCard.vue'
 import LTable from 'src/components/Table.vue'
 import PieChart from '../components/Chartjs/PieChart.vue';
 import LineChart from '../components/Chartjs/LineChart.vue';

export default {
  name: 'Dashboard',
  components: {
    ChartCard,
    StatsCard,
    LTable,
    PieChart,
    LineChart
  },
  data() {
    // Ambil tahun sekarang menggunakan Moment
  const currentYear = moment().year(); 
  const currentMonth = moment().month() + 1;

  // Generate array tahun
  const yearsList = [];
  for (let i = currentYear - 3; i <= currentYear; i++) {
    yearsList.push(i);
  }
    return {
      role: "",
      totalVesselAktif: 0,
      totalVesselSuspensions: 0,
      totalVesselExpired: 0,
      totalVesselMaintenance: 0,
      totalAirtime2month: 0,
      totalAirtime1month: 0,
      totalAirtime2week: 0,
      totalCustomers: 0,
      vesselTrend: 0,
      vesselTrendSuspension: 0,
      vesselTrendExpired: 0,
      vesselTrendMaintenance: 0,
      airtime2month: 0,
      airtime1month: 0,
      airtime2week: 0,
      customer: 0,
      loadingVessel: false,
      charts: [
        { id: 'troubleshootChart', title: 'Grafik Troubleshoot' },
        { id: 'salesChart', title: 'Grafik Penjualan' }
      ],
      salesChart: null,
      salesData: [],
      monthNames: ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"],
      years: yearsList,
      filter: {
        category: 'airtime',
        year: currentYear,
        month: 'all'
      },
      tsChart: null,
      filterTS: {
      status: 'all',
      month: currentMonth,
      year: currentYear,

      allAirtimeData: [],
      recentActivitiesAirtime: null,
      recentActivitiesInvoiceItem: null,
      
    },
    
      // LIST COMPLAINT
      complaintLabels: [
        "Kabel Data Low",
        "Kabel Power Los",
        "GPS LOW",
        "JB Mati Total",
        "JB Eror",
        "Power External Low",
        "Antena Mati Total",
        "Tidak Terpantau",
        "Over Massage",
        "RPM1 Sensor (Anomali)",
        "RPM2 Sensor (Anomali)",
        "Weather (Error)"
      ],
      troubleshootData: [],
      colors: {
        "Kabel Data Low": '#2196F3',
        "Kabel Power Los": '#4CAF50',
        "GPS LOW": '#FF9800',
        "JB Mati Total": '#F44336',
        "JB Eror": '#9C27B0',
        "Power External Low": '#00BCD4',
        "Antena Mati Total": '#8BC34A',
        "Tidak Terpantau": '#E91E63',
        "Over Massage": '#FFC107',
        "RPM1 Sensor (Anomali)": '#3F51B5',
        "RPM2 Sensor (Anomali)": '#009688',
        "Weather (Error)": '#795548'
      }
    }
  },
  mounted() {
    this.fetchTotalVesselAktif();
    this.fetchTotalVesselSuspensions();
    this.fetchTotalVesselExpired();
    this.fetchTotalVesselMaintenance();
    this.fetchTotalAirtime2month();
    this.fetchTotalAirtime1month();
    this.fetchTotalAirtime2week();
    this.fetchTotalCustomers();
    this.initCharts();
    this.fetchTroubleshootData();
    this.initChartsales();
    this.fetchSalesData();
    this.initAirtimeChart();
    this.fetchAirtimeData();
    this.getRecentActivitiesAirtime();
    this.getRecentActivitiesInvoiceItem();
   
    
    
  },
  created() {
    this.getRecentActivitiesAirtime();
    this.getRecentActivitiesInvoiceItem();
  },
  computed: {
    // Logic untuk mencari angka total berdasarkan filter yang dipilih
    currentTotalRevenue() {
      if (!this.airtimeList || this.airtimeList.length === 0) return 0;
      const found = this.airtimeList.find(item => 
        parseInt(item.year) === parseInt(this.filter.year) && 
        parseInt(item.month) === parseInt(this.filter.month)
      );
      return found ? found.total : 0;
    
    }
  },
  methods: {
    goToSuspensions() {
      this.$router.push({
        path: '/admin/pengingat/renewal-airtime',
        query: {
          tab: 2,
          status: 'SUSPENSIONS'
        }
      });
    },
    goToExpired() {
      this.$router.push({
        path: '/admin/pengingat/renewal-airtime',
        query: {
          tab: 2,
          status: 'EXPIRED'
        }
      });
    },
    goToMaintenance() {
      this.$router.push({
        path: '/admin/pengingat/renewal-airtime',
        query: {
          tab: 2,
          status: 'MAINTENANCE'
        }
      });

    },
    // FUNCTION TO RETRIEVE ACTIVE SHIP DATA
    fetchTotalVesselAktif() {
        this.loadingVessel = true;
        const url = this.$baseUrl + "/api/pemesanan/pengingat/from/airtime?all=all&search_status=ACTIVE";
        
        axios.get(url, { headers: { "Authorization": "Bearer " + localStorage.getItem("accessToken") } })
        .then(res => {
          
            // Log ini penting untuk melihat isi data di Console Browser (F12)
            console.log("Response Axios:", res);

            let totalResult = 0;
            let trendResult = 0;

            // Cek struktur standar Laravel Pagination
            if (res.data && typeof res.data.total !== 'undefined') {
                totalResult = res.data.total;
                trendResult = res.data.percentage_increment || 50;
            } 
            // Cek jika dibungkus dalam properti 'data' lagi (API Resource)
            else if (res.data.data && typeof res.data.data.total !== 'undefined') {
                totalResult = res.data.data.total;
                
            }

            // Paksa Vue untuk update tampilan
            this.$set(this, 'totalVesselAktif', totalResult);
            this.$set(this, 'vesselTrend', trendResult);
        })
        .catch(err => {
            console.error("Gagal mengambil data vessel:", err);
        })
        .finally(() => {
            this.loadingVessel = false;
        });
    },
    fetchTotalVesselSuspensions() {
        this.loadingVessel = true;
        const url = this.$baseUrl + "/api/pemesanan/pengingat/from/airtime?all=all&search_status=SUSPENSIONS";
        
        axios.get(url, { headers: { "Authorization": "Bearer " + localStorage.getItem("accessToken") } })
        .then(res => {
          
            // Log ini penting untuk melihat isi data di Console Browser (F12)
            console.log("Response Axios:", res);

            let totalResult = 0;
            let trendResult = 0;

            // Cek struktur standar Laravel Pagination
            if (res.data && typeof res.data.total !== 'undefined') {
                totalResult = res.data.total;
                trendResult = res.data.percentage_increment || 5;
            } 
            // Cek jika dibungkus dalam properti 'data' lagi (API Resource)
            else if (res.data.data && typeof res.data.data.total !== 'undefined') {
                totalResult = res.data.data.total;
                
            }

            // Paksa Vue untuk update tampilan
            this.$set(this, 'totalVesselSuspensions', totalResult);
            this.$set(this, 'vesselTrendSuspension', trendResult);
        })
        .catch(err => {
            console.error("Gagal mengambil data vessel:", err);
        })
        .finally(() => {
            this.loadingVessel = false;
        });
    },
    fetchTotalVesselExpired() {
        this.loadingVessel = true;
        const url = this.$baseUrl + "/api/pemesanan/pengingat/from/airtime?all=all&search_status=EXPIRED";
        
        axios.get(url, { headers: { "Authorization": "Bearer " + localStorage.getItem("accessToken") } })
        .then(res => {
          
            // Log ini penting untuk melihat isi data di Console Browser (F12)
            console.log("Response Axios:", res);

            let totalResult = 0;
            let trendResult = 0;

            // Cek struktur standar Laravel Pagination
            if (res.data && typeof res.data.total !== 'undefined') {
                totalResult = res.data.total;
                trendResult = res.data.percentage_increment || 10;
            } 
            // Cek jika dibungkus dalam properti 'data' lagi (API Resource)
            else if (res.data.data && typeof res.data.data.total !== 'undefined') {
                totalResult = res.data.data.total;
                
            }

            // Paksa Vue untuk update tampilan
            this.$set(this, 'totalVesselExpired', totalResult);
            this.$set(this, 'vesselTrendExpired', trendResult);
        })
        .catch(err => {
            console.error("Gagal mengambil data vessel:", err);
        })
        .finally(() => {
            this.loadingVessel = false;
        });
    },
    fetchTotalVesselMaintenance() {
        this.loadingVessel = true;
        const url = this.$baseUrl + "/api/pemesanan/pengingat/from/airtime?all&search_status=MAINTENANCE";
        
        axios.get(url, { headers: { "Authorization": "Bearer " + localStorage.getItem("accessToken") } })
        .then(res => {
          
            // Log ini penting untuk melihat isi data di Console Browser (F12)
            console.log("Response Axios:", res);

            let totalResult = 0;
            let trendResult = 0;

            // Cek struktur standar Laravel Pagination
            if (res.data && typeof res.data.total !== 'undefined') {
                totalResult = res.data.total;
                trendResult = res.data.percentage_increment || 5;
            } 
            // Cek jika dibungkus dalam properti 'data' lagi (API Resource)
            else if (res.data.data && typeof res.data.data.total !== 'undefined') {
                totalResult = res.data.data.total;
                
            }

            // Paksa Vue untuk update tampilan
            this.$set(this, 'totalVesselMaintenance', totalResult);
            this.$set(this, 'vesselTrendMaintenance', trendResult);
        })
        .catch(err => {
            console.error("Gagal mengambil data vessel:", err);
        })
        .finally(() => {
            this.loadingVessel = false;
        });
    },
    fetchTotalAirtime2month() {
        this.loadingVessel = true;
        const url = this.$baseUrl + "/api/pemesanan/pengingat/from/airtime?all&status=2month&search_status=ACTIVE";
        
        axios.get(url, { headers: { "Authorization": "Bearer " + localStorage.getItem("accessToken") } })
        .then(res => {
          
            // Log ini penting untuk melihat isi data di Console Browser (F12)
            console.log("Response Axios:", res);

            let totalResult = 0;
            let trendResult = 0;

            // Cek struktur standar Laravel Pagination
            if (res.data && typeof res.data.total !== 'undefined') {
                totalResult = res.data.total;
                trendResult = res.data.percentage_increment || 5;
            } 
            // Cek jika dibungkus dalam properti 'data' lagi (API Resource)
            else if (res.data.data && typeof res.data.data.total !== 'undefined') {
                totalResult = res.data.data.total;
                
            }

            // Paksa Vue untuk update tampilan
            this.$set(this, 'totalAirtime2month', totalResult);
            this.$set(this, 'airtime2month', trendResult);
        })
        .catch(err => {
            console.error("Gagal mengambil data vessel:", err);
        })
        .finally(() => {
            this.loadingVessel = false;
        });
    },
    fetchTotalAirtime1month() {
        this.loadingVessel = true;
        const url = this.$baseUrl + "/api/pemesanan/pengingat/from/airtime?all&status=1month&search_status=ACTIVE";
        
        axios.get(url, { headers: { "Authorization": "Bearer " + localStorage.getItem("accessToken") } })
        .then(res => {
          
            // Log ini penting untuk melihat isi data di Console Browser (F12)
            console.log("Response Axios:", res);

            let totalResult = 0;
            let trendResult = 0;

            // Cek struktur standar Laravel Pagination
            if (res.data && typeof res.data.total !== 'undefined') {
                totalResult = res.data.total;
                trendResult = res.data.percentage_increment || 5;
            } 
            // Cek jika dibungkus dalam properti 'data' lagi (API Resource)
            else if (res.data.data && typeof res.data.data.total !== 'undefined') {
                totalResult = res.data.data.total;
                
            }

            // Paksa Vue untuk update tampilan
            this.$set(this, 'totalAirtime1month', totalResult);
            this.$set(this, 'airtime1month', trendResult);
        })
        .catch(err => {
            console.error("Gagal mengambil data vessel:", err);
        })
        .finally(() => {
            this.loadingVessel = false;
        });
    },
    fetchTotalAirtime2week() {
        this.loadingVessel = true;
        const url = this.$baseUrl + "/api/pemesanan/pengingat/from/airtime?all&status=2week&search_status=ACTIVE";
        
        axios.get(url, { headers: { "Authorization": "Bearer " + localStorage.getItem("accessToken") } })
        .then(res => {
          
            // Log ini penting untuk melihat isi data di Console Browser (F12)
            console.log("Response Axios:", res);

            let totalResult = 0;
            let trendResult = 0;

            // Cek struktur standar Laravel Pagination
            if (res.data && typeof res.data.total !== 'undefined') {
                totalResult = res.data.total;
                trendResult = res.data.percentage_increment || 5;
            } 
            // Cek jika dibungkus dalam properti 'data' lagi (API Resource)
            else if (res.data.data && typeof res.data.data.total !== 'undefined') {
                totalResult = res.data.data.total;
                
            }

            // Paksa Vue untuk update tampilan
            this.$set(this, 'totalAirtime2week', totalResult);
            this.$set(this, 'airtime2week', trendResult);
        })
        .catch(err => {
            console.error("Gagal mengambil data vessel:", err);
        })
        .finally(() => {
            this.loadingVessel = false;
        });
    },
     
    fetchTotalCustomers() {
        this.loadingVessel = true;
        const url = this.$baseUrl + "/api/master/klien";
        
        axios.get(url, { headers: { "Authorization": "Bearer " + localStorage.getItem("accessToken") } })
        .then(res => {
          
            // Log ini penting untuk melihat isi data di Console Browser (F12)
            console.log("Response Axios:", res);

            let totalResult = 0;
            let trendResult = 0;

            // Cek struktur standar Laravel Pagination
            if (res.data && typeof res.data.total !== 'undefined') {
                totalResult = res.data.total;
                trendResult = res.data.percentage_increment || 5;
            } 
            // Cek jika dibungkus dalam properti 'data' lagi (API Resource)
            else if (res.data.data && typeof res.data.data.total !== 'undefined') {
                totalResult = res.data.data.total;
                
            }

            // Paksa Vue untuk update tampilan
            this.$set(this, 'totalCustomers', totalResult);
            this.$set(this, 'customer', trendResult);
        })
        .catch(err => {
            console.error("Gagal mengambil data vessel:", err);
        })
        .finally(() => {
            this.loadingVessel = false;
        });
    },
     
     // Sales Chart
    fetchSalesData() {
      const token = localStorage.getItem("accessToken");
      
      // Logika pemilihan URL
      let endpoint = "/api/report/json/airtime";
      if (this.filter.category === 'invoice') {
        endpoint = "/api/report/json/unit-sales";
      }

      const url = this.$baseUrl + endpoint;
      const payload = { year: this.filter.year };

      axios.post(url, payload, { 
        headers: { "Authorization": "Bearer " + token } 
      })
      .then(res => {
        this.salesData = res.data.data || [];
        this.updateChart(); 
      })
      .catch(err => {
        console.error("Failed to load API data:", err);
        this.salesData = [];
        this.updateChart();
      });
    },

    initChartsales() {
      const ctx = document.getElementById('salesChart').getContext('2d');
      const gradient = ctx.createLinearGradient(0, 0, 0, 400);
      gradient.addColorStop(0, 'rgba(52, 70, 117, 0.4)');
      gradient.addColorStop(1, 'rgba(52, 70, 117, 0.0)');

      this.salesChart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.monthNames,
          datasets: [{
            label: 'Sales Data',
            borderColor: '#344675',
            pointBackgroundColor: '#344675',
            pointRadius: 4,
            backgroundColor: gradient,
            fill: true,
            borderWidth: 3,
            data: new Array(12).fill(0)
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              gridLines: { drawBorder: false, color: 'rgba(29,140,248,0.1)' },
              ticks: { 
                padding: 10, 
                fontColor: "#9e9e9e",
                beginAtZero: true,
                precision: 0
              }
            }],
            xAxes: [{
              gridLines: { display: false },
              ticks: { padding: 10, fontColor: "#9e9e9e" }
            }]
          }
        }
      });
    },
    updateChart() {
      if (!this.salesChart) return;

      // 1. Inisialisasi array 12 bulan dengan angka 0
      let chartValues = new Array(12).fill(0);
      const selectedYear = parseInt(this.filter.year);
      const selectedMonth = this.filter.month; // Bisa 'all' atau angka 1-12

      // 2. Mapping data dari API
      this.salesData.forEach(item => {
        if (parseInt(item.year) === selectedYear) {
          const monthIndex = parseInt(item.month) - 1;
          
          // LOGIKA FILTER BULAN:
          // Jika filter adalah 'all', masukkan semua data bulan.
          // Jika filter adalah angka, hanya masukkan data jika index bulannya cocok.
          if (selectedMonth === 'all' || parseInt(selectedMonth) === parseInt(item.month)) {
            if (monthIndex >= 0 && monthIndex < 12) {
              chartValues[monthIndex] = parseFloat(item.total);
            }
          }
        }
      });

      // 3. Update Label Dataset
      const categoryLabel = this.filter.category === 'airtime' ? 'Total Airtime' : 'Total Invoice Unit';
      const monthLabel = selectedMonth === 'all' ? '' : `(${this.monthNames[selectedMonth - 1]})`;
      
      this.salesChart.data.datasets[0].label = `${categoryLabel} ${monthLabel}`;
      this.salesChart.data.datasets[0].data = chartValues;

      // 4. Update Sumbu X (Opsional)
      // Jika hanya 1 bulan, mungkin kamu ingin memperjelas tampilannya
      if (selectedMonth !== 'all') {
        this.salesChart.options.scales.xAxes[0].ticks.fontStyle = 'bold';
      } else {
        this.salesChart.options.scales.xAxes[0].ticks.fontStyle = 'normal';
      }

      // 5. Atur skala Y dan Render ulang
      const maxVal = Math.max(...chartValues, 0);
      this.salesChart.options.scales.yAxes[0].ticks.suggestedMax = maxVal + (maxVal * 0.1) + 5;
      
      this.salesChart.update();
    },
    

    //TROUBLESSHOOT
    fetchTroubleshootData() {
      const url = this.$baseUrl + "/api/report/graph-data/troubleshoot";
      const token = localStorage.getItem("accessToken");

      axios.get(url, { 
        headers: { "Authorization": "Bearer " + token } 
      })
      .then(res => {
        this.troubleshootData = res.data;
        this.updateTSChart(); 
      })
      .catch(err => {
        console.error("Gagal memuat data:", err);
      });
    },

    initCharts() {
      const ctx = document.getElementById('troubleshootChart').getContext('2d');
      
      this.tsChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: this.complaintLabels,
          datasets: [{
            label: 'Total Kasus',
            data: [],
            backgroundColor: [],
            borderRadius: 5,
            barThickness: 15 
          }]
        },
        options: {
          indexAxis: 'y', // MEMBUAT BAR HORIZONTAL (Agar 0 ada di kiri bawah)
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: { right: 50, left: 10, top: 10, bottom: 10 }
          },
          plugins: { 
            legend: { display: false } 
          },
          scales: {
            x: { 
              type: 'linear',
              beginAtZero: true, // WAJIB: Memaksa mulai dari 0
              min: 0,            // MENGHILANGKAN ANGKA NEGATIF (-0.2, dst)
              ticks: {
                stepSize: 1,     // Hanya loncat angka bulat (1, 2, 3)
                precision: 0,    // Hilangkan desimal (.0)
                callback: function(value) {
                  if (value % 1 === 0) return value;
                }
              },
              grid: {
                color: '#f0f0f0',
                drawBorder: false
              }
            },
            y: { 
              type: 'category',
              grid: { 
                display: false, 
                drawBorder: false 
              },
              ticks: {
                font: { size: 11 }
              }
            }
          }
        }
      });
    },

    updateTSChart() {
      if (!this.tsChart || !this.troubleshootData) return;

      const filtered = this.troubleshootData.filter(item => {
        return item.month == this.filterTS.month && item.year == this.filterTS.year;
      });

      const values = this.complaintLabels.map(label => {
        const found = filtered.find(d => d.complaint === label);
        // Pastikan data yang masuk adalah angka bulat positif
        const total = found ? Math.floor(Number(found.total)) : 0;
        return total < 0 ? 0 : total; 
      });

      const bgColors = this.complaintLabels.map(label => this.colors[label] || '#4e73df');

      this.tsChart.data.datasets[0].data = values;
      this.tsChart.data.datasets[0].backgroundColor = bgColors;

      // DINAMIS: Supaya grid sumbu X tidak kaku jika data hanya sedikit
      const maxVal = Math.max(...values, 0);
      this.tsChart.options.scales.x.suggestedMax = maxVal < 5 ? 5 : maxVal + 1;

      this.tsChart.update();
    },
    fetchAirtimeData() {
      const url = this.$baseUrl + "/api/report/json/totalairtime";
      const token = localStorage.getItem("accessToken");

      axios.post(url, { year: this.filter.year }, { 
        headers: { "Authorization": "Bearer " + token } 
      })
      .then(res => {
        if (res.data.status === "success") {
          this.airtimeList = res.data.data || [];
          this.updateAirtimeDashboard();
        }
      })
      .catch(err => console.error("Gagal memuat data:", err));
    },

    updateAirtimeDashboard() {
      if (!this.airtimeRevenueChart) return;

      let chartData = new Array(12).fill(0);
      this.airtimeList.forEach(item => {
        if (parseInt(item.year) === parseInt(this.filter.year)) {
          const mIndex = parseInt(item.month) - 1;
          chartData[mIndex] = parseFloat(item.total);
        }
      });

      this.airtimeRevenueChart.data.datasets[0].data = chartData;
      this.airtimeRevenueChart.update();
    },

    initAirtimeChart() {
      const ctx = document.getElementById('airtimeRevenueChart').getContext('2d');
      this.airtimeRevenueChart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"],
          datasets: [{
            label: 'Airtime Income',
            borderColor: '#2196F3',
            backgroundColor: 'rgba(33, 150, 243, 0.1)',
            borderWidth: 3,
            fill: true,
            data: new Array(12).fill(0),
            tension: 0.3
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                callback: (value) => this.formatCurrency(value)
              }
            }]
          }
        }
      });
    },

    formatCurrency(value) {
      if (!value) return "Rp 0";
      return "Rp " + parseFloat(value).toLocaleString('id-ID');
    },
    getRecentActivitiesAirtime() {
        const token = localStorage.getItem("accessToken");
        const url = this.$baseUrl + "/api/report/json/activities-airtime";

        axios.post(url, {}, { 
          headers: { "Authorization": "Bearer " + token } 
        })
        .then(res => {
          if (res.data.status === 'success') {
            // Mengisi objek yang sudah didaftarkan di data()
            this.recentActivitiesAirtime = res.data.data;
          }
        })
        .catch(err => {
          console.error("Gagal mengambil aktivitas airtime terbaru:", err);
          // Kembalikan ke format objek kosong bawaan
          this.recentActivitiesAirtime = { invoice_no: '', client_name: '', created_at: '' };
        });
      },

      getRecentActivitiesInvoiceItem() {
        const token = localStorage.getItem("accessToken");
        const url = this.$baseUrl + "/api/report/json/activities-invoiceitem";

        axios.post(url, {}, { 
          headers: { "Authorization": "Bearer " + token } 
        })
        .then(res => {
          if (res.data.status === 'success') {
            // Mengisi objek yang sudah didaftarkan di data()
            this.recentActivitiesInvoiceItem = res.data.data;
          }
        })
        .catch(err => {
          console.error("Gagal mengambil aktivitas airtime terbaru:", err);
          // Kembalikan ke format objek kosong bawaan
          this.recentActivitiesInvoiceItem = { invoice_no: '', client_name: '', created_at: '' };
        });
      },
    
    formatDate(dateString) {
      if (!dateString) return '-';
      
      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '-';

        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);

        // Jika di bawah 1 menit
        if (diffInSeconds < 60) {
          return 'Baru saja';
        }

        // Jika di bawah 1 jam (tampilkan menit)
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        if (diffInMinutes < 60) {
          return `${diffInMinutes} menit yang lalu`;
        }

        // Jika di bawah 24 jam (tampilkan jam)
        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) {
          return `${diffInHours} jam yang lalu`;
        }

        // Jika sudah lewat 1 hari, tampilkan "Kemarin"
        if (diffInHours < 48) {
          return 'Kemarin';
        }

        // Jika lebih dari 2 hari, kembali ke format tanggal standar
        return date.toLocaleDateString('id-ID', {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        });
      } catch (error) {
        return '-';
      }
    }
    
  }
}
</script>

<style scoped>
.card-radius {
  border-radius: 15px;
}
.list-group-item {
  border: none;
  padding: 1rem;
}
.list-group-item:not(:last-child) {
  border-bottom: 1px solid #eee;
}
.fa-file-invoice {
  color: #9C27B0;
}
.fa-clock {
  color: #2196F3;
}
.fa-file-alt {
  color: #FF9800;
}
.fa-database {
  color: #2196F3;
}
.card {
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
        }
        .card:hover {
            transform: translateY(-4px);
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        }
        .card::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 4px;
            background: linear-gradient(90deg, #3B82F6, #8B5CF6);
            transform: scaleX(0);
            transition: transform 0.3s ease;
        }
        .card:hover::before {
            transform: scaleX(1);
        }
        .gradient-border {
            position: relative;
        }
        .gradient-border::after {
            content: '';
            position: absolute;
            inset: 0;
            border-radius: inherit;
            padding: 1px;
            background: linear-gradient(45deg, #3B82F6, #8B5CF6, #EC4899, #F59E0B);
            -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
            mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
            -webkit-mask-composite: xor;
            mask-composite: xor;
        }
.card-vessel {
    background: linear-gradient(135deg, #4CAF50, #45a049);
    transition: transform 0.3s ease;
    border: none; /* Menghilangkan border default card */
}

.card-vessel:hover {
    transform: translateY(-5px);
}

/* Lingkaran Ikon - Fokus pada Centering */
/* Lingkaran Ikon - Fokus pada Centering Mutlak */
.icon-circle-wrapper {
    background: rgba(255, 255, 255, 0.2); 
    width: 60px;  
    height: 60px; 
    
    /* Menggunakan Grid agar benar-benar di tengah */
    display: grid !important;
    place-items: center !important; 
    
    border-radius: 50%;      
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.05);
    flex-shrink: 0; 
    
    /* Memastikan tidak ada padding yang mendorong ikon keluar dari tengah */
    padding: 0 !important;
    overflow: hidden;
}

/* Ukuran Ikon di dalam lingkaran */
.icon-circle-wrapper i {
    font-size: 1.8rem;
    color: #ffffff;
    display: block !important;
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1 !important; 
    
    /* GESER KE KIRI: Gunakan nilai negatif */
    /* Semakin besar angka negatifnya, semakin ke kiri posisinya */
    transform: translateX(-8px) !important; 
    
    filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));
}

.card-radius {
    border-radius: 15px;
}
.status-dot {
  height: 8px;
  width: 8px;
  background-color: #f1c40f; /* Kuning terang */
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
  box-shadow: 0 0 5px #f1c40f;
}

.trend-note {
  font-size: 11px;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.15); /* Hitam sangat transparan */
  padding: 4px 10px;
  border-radius: 20px;
  width: fit-content;
}
</style>